import React, { useState } from "react";
import AndroidQR from "../../assets/svg/AndroidQR";
import GooglePlay from "../../assets/svg/GooglePlay";
import { useNavigate } from "react-router-dom";
export const DownloadApp = ({ handleClose }) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-xs">
      <div className="bg-white rounded-lg max-w-lg w-full mx-4 p-6 relative overflow-y-auto max-h-[90vh]">
        <div
          className={`flex ${
            isMobile ? "flex-col items-center" : "flex-row"
          } space-x-4`}
        >
          <div
            className="cursor-pointer hover:opacity-80"
            onClick={() => {
              if (isMobile) {
                navigate('/download');
              }
            }}
          >
            <AndroidQR />
          </div>
          <div
            className={`content-center font-raleway ${
              isMobile ? "mt-2" : "mt-0"
            }`}
          >
            <div className="mb-8">
              <h2 className="text-3xl font-semibold text-primary-500 text-bold">
                The Anyaya App is here!
              </h2>
              <p className="text-md font-medium text-primary-600">
                Making milestones, creating memories - now made easier
              </p>
            </div>
            {/* <div
              className="cursor-pointer hover:opacity-80"
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.anyaya",
                  "_blank"
                );
              }}
            >
              <GooglePlay />
            </div> */}
          </div>
        </div>
        <div className="mt-4 flex justify-center">
          <button
            onClick={handleClose}
            className="bg-primary-500 w-full text-white py-3 px-8 rounded-lg font-medium text-sm"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};
